import { useEffect } from "react";

const BookJavits2 = () => {
  useEffect(() => {
    const metaNoIndex = document.createElement("meta");
    metaNoIndex.name = "robots";
    metaNoIndex.content = "noindex, nofollow";
    document.head.appendChild(metaNoIndex);
    return () => {
      document.head.removeChild(metaNoIndex);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black overflow-hidden">
      <iframe
        src="https://quietcove.wiseingress.com/#/quietcove;uid=2bc8eaee-20bc-4835-b5b6-878649bd4355;source=iframe"
        className="w-full h-full border-0"
        style={{ minWidth: '100vw', minHeight: '100vh' }}
        allow="payment *; clipboard-read; clipboard-write"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        title="Quiet Corner Booking Kiosk - Javits 2"
      />
    </div>
  );
};

export default BookJavits2;
